module.exports = __webpack_public_path__ + "img/leaves-illustration.a061d5db.svg";